import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';
import 'slick-carousel';

export default () => {
	domContentLoaded(() => {
		// 体験会のスライダー
		$('.js-trial-slider').on('init breakpoint setPosition', () => {
			let maxHeight = 0;
			$('.p-home-trial-box').each((idx, elem) => {
				$(elem).css('height', 'auto');
				const height = Math.floor($(elem).height());
				if (maxHeight < height) {
					maxHeight = height;
				}
			});
			$('.p-home-trial-box').height(maxHeight);
		}).slick({
			slidesToShow: 3,
			adaptiveHeight: true,
			infinite: false,
			prevArrow: '<button type="button" class="js-trial-arrow prev"></button>',
			nextArrow: '<button type="button" class="js-trial-arrow next"></button>',
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
			],
		});
	});
};
